/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Empty_BodyInputs */

const en_us2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish a workout and your volume, consistency and strength start showing up here, week by week.`)
};

const pt_br2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine um treino e o volume, a consistência e a força começam a aparecer aqui, semana a semana.`)
};

const es_419_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina un entrenamiento y tu volumen, tu constancia y tu fuerza empiezan a aparecer aquí, semana a semana.`)
};

const pt_pt2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina um treino e o volume, a consistência e a força começam a aparecer aqui, semana a semana.`)
};

const fr_fr2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine une séance et ton volume, ta régularité et ta force commenceront à s'afficher ici, semaine après semaine.`)
};

const de_de2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließ ein Training ab, dann erscheinen hier Woche für Woche dein Volumen, deine Beständigkeit und deine Kraft.`)
};

const it_it2_progress_empty_body = /** @type {(inputs: Progress_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa un allenamento e volume, costanza e forza inizieranno a comparire qui, settimana dopo settimana.`)
};

/**
* | output |
* | --- |
* | "Finish a workout and your volume, consistency and strength start showing up here, week by week." |
*
* @param {Progress_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_empty_body = /** @type {((inputs?: Progress_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_empty_body(inputs)
	if (locale === "es-419") return es_419_progress_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_empty_body(inputs)
	if (locale === "de-DE") return de_de2_progress_empty_body(inputs)
	if (locale === "it-IT") return it_it2_progress_empty_body(inputs)
	return en_us2_progress_empty_body(inputs)
});
export { progress_empty_body as "progress.empty_body" }